module.exports = __webpack_public_path__ + "static/img/bg_manufacture.0e7a1467.jpg";